module.exports = "https://coursera_assets.s3.amazonaws.com/images/96e9180794384c168dad4005fa95f5f7.png";